export default {
  signUpSuccess: "Succesfully registered! You've been signed in as well.",
  signUpFailure:
    "Registration failed. Email may be taken, or passwords don't match.",
  signInSuccess: "Welcome!",
  signInFailure:
    "Failed to sign in. Check your email and password and try again.",
  signOutSuccess: "Come back soon!",
  changePasswordSuccess: "Password changed successfully!",
  changePasswordFailure:
    "Failed to change passwords. Check your old password and try again.",
  createExampleSucess: "Click home page icon to wiew your example.",
  createCommentSucess: "Comment is created successfully",
  createCommentFailure: "Comment is not created. Failure",
  displayUserExamplesSuccess: "Displaying all my examples.",
  displayUserExamplesFailure: "Can`t be displayed for the moment",
  deleteExampleSuccess: "Example is deleted sucessfully.",
  updateExampleSuccess: "Example is updated successfully.",

  displayUserInfoSuccess:
    "My account information is being displayed successfully",
  displayUserInfoFailure:
    "My account information could'nt be displayed. Sorry try again!",
  updateUserInfoSuccess: "Your account information is updated successfully",
};
